<div class="program-content">
  <h2 *ngIf="!_SelectedYear" class="mat-display-2">Programm</h2>
  <div *ngIf="showSpinner" class="progress-spinner">
    <mat-spinner></mat-spinner>
  </div>
  <div class="content-page">
    <ng-template [ngIf]="!_SelectedYear">
      <div class="label">
        <p style="text-align: center">
          Wir informieren euch über aktuelle Angebote, alle Entwicklungen und
          Neuigkeiten zeitnah auf unserem Instagram Account
          <a
            href="https://www.instagram.com/bildungswerk_vielfalt/"
            target="_blank"
            class="bildungswerk_vielfalt"
          >bildungswerk_vielfalt</a
          >. Lasst gern ein Abo da, dann seid ihr immer rechtzeitig über alles
          informiert.<br>
          Du möchtest einen Sprachkurs bei uns besuchen und weißt noch nicht genau, welcher zu dir passt? <br>
          Wir helfen dir: <br>Sprachkursberatung und Einstufungstest <br>
          Funda Aksoy | <a href="tel:0231/28678 166">0231/28678 165</a>
        </p>
      </div>
    </ng-template>


    <div *ngIf="mobileViewForFilters" class="mobile-dropdown-container">
      <div class="top-section" (click)="onDropDownToggle($event)">
        <a mat-button>{{ displayName }}</a>
        <i
          *ngIf="toggleDownIcon"
          style="color: black"
          class="fa fa-chevron-down"
          [ngClass]="{ showIcon: toggleDownIcon, hideIcon: !toggleDownIcon }"
        ></i>
        <i
          *ngIf="toggleUpIcon"
          style="color: black"
          class="fa fa-chevron-up"
          [ngClass]="{ showIcon: toggleUpIcon, hideIcon: !toggleUpIcon }"
        ></i>
      </div>
      <div
        *ngIf="toggleFilterListDisplay"
        [ngClass]="{
          displayFilterList: toggleFilterListDisplay,
          hideFilterList: !toggleFilterListDisplay
        }"
      >
        <a
          class="lastSelection"
          *ngIf="showAlle"
          (click)="onDropDownToggle($event)"
          mat-button
          (click)="filterCategory('all')"
        >Alle</a
        >
        <div class="bottom-list" *ngFor="let category of categories">
          <a mat-button (click)="filterCategory(category.id)">{{
              category.name
            }}</a>
        </div>
      </div>
    </div>

    <mat-toolbar *ngIf="desktopViewrForFIlters" class="admin-nav">
      <ul class="nav">
        <li>
          <a
            mat-button
            (click)="filterCategory('all')"
            [class.active]="selectedAll"
          >Alle</a
          >
        </li>
        <li *ngFor="let category of categories">
          <a
            mat-button
            [class.active]="category.selected"
            (click)="filterCategory(category.id)">
            {{ category.name }}
          </a>
        </li>
      </ul>
    </mat-toolbar>
    <div class="allCourses">
      <div class="courseContent">
        <div
          class="carWrapper"
          *ngFor="let course of courses"
          (click)="handleNavigateDetailCourse(course.id)"
        >
          <div class="titleDiv">
            <div class="" style="font-size: medium !important">
              {{ course.title }}
            </div>
            <div class="triangle"></div>
            <div class="toolTipM">
              {{ course.fullTitle }}
            </div>
          </div>
          <div class="contentDiv">
            <div class="itemLine">
              <p class="label">Wann:</p>
              <p class="value">
                {{ course.start_date | date }} - {{
                  course.end_date | date
                }}<br/>
                {{ course.days }}
              </p>
            </div>
            <div class="itemLine">
              <p class="label">U-Std.:</p>
              <p class="value">{{ course.duration }}</p>
            </div>

            <div class="itemLine">
              <p class="label">Kursgebühr:</p>
              <p class="value">
                {{ course.course_fees | currency : "EUR" }}
              </p>
            </div>

            <div class="itemLine">
              <p class="label">Kategorie</p>
              <p class="value">{{ course.category_name }}</p>
            </div>
            <div class="itemLine">
              <p class="label">Kurs-Nr:</p>
              <p class="value">{{ course.code }}</p>
            </div>
            <div class="location itemLine">
              <p class="label">Wo:</p>
              <p class="value">{{ course.location }}</p>
            </div>
            <div *ngIf="course.lead" class="course-lead itemLine">
              <p class="label">Leitung:</p>
              <p class="value">{{ course.lead }}</p>
            </div>
          </div>
          <div class="courseDescription">
            <p>
              {{ course.content }}
            </p>
          </div>
        </div>
      </div>

      <mat-paginator
        class="custom-mat-paginator"
        *ngIf="lockNextbutton"
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        showFirstLastButtons
        (page)="OnPageChange($event)"
        aria-label="Select page"
        disabled="false"
      >
      </mat-paginator>
      <mat-paginator
        class="custom-mat-paginator"
        *ngIf="!lockNextbutton"
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        showFirstLastButtons
        (page)="OnPageChange($event)"
        aria-label="Select page"

        disabled="lockNextbutton"
      >
      </mat-paginator>
    </div>
  </div>
</div>
